import {fileAttachmentFieldNameAttribute} from './formFields';

export const formValidationSelector = {
  field: `input:not(.search):not([type="reset"]):not([type="button"]):not([type="submit"]):not([${fileAttachmentFieldNameAttribute}]), textarea, select`,
};
